module.exports = "<div class=\"spinner-wrapper\">\r\n  <app-spinner [message]=\"this.message\" [successErrorMessgae]=\"this.successErrorMessgae\"></app-spinner>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/spinner-overlay/spinner-overlay.component.html
// module id = ../../../../../src/app/spinner-overlay/spinner-overlay.component.html
// module chunks = main